import ClusterModal from './ClusterModal';

function AddEditClusters({ edit }) {
  if (edit) return <ClusterModal mode={'edit'} />;
  return <ClusterModal />;
}

export default AddEditClusters;
